import { LogOut, User } from 'lucide-react';
import { useAuthStore } from '../stores/auth-store';

export function UserMenu() {
  const { user, logout } = useAuthStore();

  if (!user) return null;

  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100">
          <User className="h-4 w-4 text-primary-700" />
        </div>
        <div className="hidden md:block">
          <p className="text-sm font-medium text-gray-900">{user.name}</p>
          <p className="text-xs text-gray-500">{user.username}</p>
        </div>
      </div>
      <button
        onClick={logout}
        className="rounded-lg p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
        title="Sign out"
      >
        <LogOut className="h-5 w-5" />
      </button>
    </div>
  );
}
